import { IState } from 'legacy/lut/store'

export const selectConfigurationState = (state: IState) => state.partner360.configuration
